export default __webpack_public_path__ + "static/media/user_import_template.64bd49f1.csv";